import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';

export interface AuthorLabelProps {
  /** Display name of the author, or 'You' for the current user. */
  author: string;
}

/**
 * Renders "· Created by <author>" next to a subtitle1 title.
 */
export const AuthorLabel: FC<AuthorLabelProps> = ({ author }) => (
  <Typography variant="subtitle1" noWrap sx={{ flexShrink: 0, fontSize: 12, fontWeight: 'fontWeightRegular', lineHeight: 1.3, opacity: 0.8 }}>
    <Box component="span" sx={{ color: 'text.secondary' }}>
      {'· Created by '}
    </Box>
    <Box component="span" sx={{ color: 'text.primary' }}>
      {author}
    </Box>
  </Typography>
);
